module.exports = __webpack_public_path__ + "static/img/4ccfb65fe8a148e7aeda9014bddd948a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUsBg.jpg
// module id = FhRa
// module chunks = 1